{
    "I9eo-Xpq4Oq78lJStDBs0": {
        "key": "I9eo-Xpq4Oq78lJStDBs0",
        "position": {
            "x": 3,
            "y": 4,
            "z": 1
        }
    },
    "3PJGtJ5bEZvk0tBwlB2wk": {
        "key": "3PJGtJ5bEZvk0tBwlB2wk",
        "position": {
            "x": 4,
            "y": 4,
            "z": 1
        }
    },
    "q3ODhAgMGCBMe3wkYqamH": {
        "key": "q3ODhAgMGCBMe3wkYqamH",
        "position": {
            "x": 3,
            "y": 5,
            "z": 1
        }
    }
}